import { Button, Modal } from 'react-bootstrap'

export const ReleaseModal = (props) => {
    return (
        <Modal
            show={props.showModal}
            dialogClassName='lock-warning-signature-modal-dialog '
            backdropClassName='veil'
            animation={false}
            centered
            autoFocus={false}
            onHide={props.close}
            onKeyPress={(e) => {
                var key = e.which || e.keyCode || 0
                key === 13 && e.preventDefault()
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ display: 'inline-block' }}>
                    Warning: Closing due to inactivity
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>If no changes are made shortly, this window will close.</Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={() => props.close()}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}